// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ff4336c4","87":"afd762a1","215":"9d48fd90","256":"2489c61b","367":"a6f6ef64","422":"5f198d8b","474":"73108bd7","543":"8efbcdd1","694":"a8de25c8","754":"3c271dcb"}[chunkId] + ".chunk.js";
};